export default {
	CREATION: 'creation',
	EDITION: 'edition',
}
